import { useCallback } from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { webContainerClient } from "@editor/trpc/webContainer";

import { useNextDevServer } from "@/features/code-execution/context";

/**
 * Hook to fetch and update logo.ts in the web container with the latest
 * logo URL from the project
 */
export const useFetchLogoForWebContainer = () => {
  const projectId = useCurrentProjectId();
  const { mountAdditionalFiles } = useNextDevServer();

  const updateLogo = useCallback(async () => {
    if (!projectId) {
      return;
    }

    const fileTree = await webContainerClient.getLogoFileTree.query({
      projectId,
    });
    await mountAdditionalFiles?.(fileTree);
  }, [projectId, mountAdditionalFiles]);

  return { updateLogo };
};
